const powerBICheatSheet = {
  id: "powerbi",
  title: "Power BI Cheatsheet",
  description:
    "Complete guide to data analysis and visualization with Power BI",
  language: "powerbi",
  category: "Business Intelligence",
  level: "All Levels",
  sections: [
    {
      title: "Getting Started",
      items: [
        {
          title: "Basic DAX",
          content: "Essential DAX formulas and functions",
          code: `# Basic Calculations
Total Sales = SUM(Sales[Amount])
Average Price = AVERAGE(Products[Price])
Count Customers = DISTINCTCOUNT(Customers[ID])

# Time Intelligence
Sales YTD = TOTALYTD(SUM(Sales[Amount]), 'Date'[Date])
Sales PY = CALCULATE(SUM(Sales[Amount]), SAMEPERIODLASTYEAR('Date'[Date]))
Growth % = DIVIDE([Sales] - [Sales PY], [Sales PY])

# Filter Functions
Filtered Sales = CALCULATE(SUM(Sales[Amount]), 
    FILTER(Sales, Sales[Region] = "West"))
Top Products = TOPN(5, VALUES(Products[Name]), [Total Sales])

# Logical Functions
High Value = IF([Total Sales] > 1000, "High", "Low")
Category = SWITCH(TRUE(),
    [Total Sales] > 1000, "Premium",
    [Total Sales] > 500, "Standard",
    "Basic")`,
          note: "Basic Power BI DAX formulas and functions.",
        },
      ],
    },
    {
      title: "Data Modeling",
      items: [
        {
          title: "Relationships",
          content: "Create and manage table relationships",
          code: `# Create Relationships
Drag primary key to foreign key
Configure properties:
- Cardinality: 1:1, 1:*, *:*
- Cross filter: Single, Both
- Active: Yes/No

# Best Practices
- Star Schema design
- Avoid circular relationships
- Use bi-directional when needed
Example: Sales[ProductID] → Products[ID]`,
          note: "Optimize relationships for better performance",
        },
      ],
    },
    {
      title: "Advanced DAX",
      items: [
        {
          title: "Complex Calculations",
          content: "Advanced DAX patterns and calculations",
          code: `# Rolling Averages
Rolling 3M Avg = 
AVERAGEX(
    DATESINPERIOD(
        'Date'[Date],
        LASTDATE('Date'[Date]),
        -3,
        MONTH
    ),
    [Daily Sales]
)

# Market Share
Market Share = 
DIVIDE(
    [Department Sales],
    [Total Company Sales],
    0
)

# Previous Period Comparison
Sales vs PY = 
VAR CurrentSales = [Total Sales]
VAR PreviousSales = 
    CALCULATE(
        [Total Sales],
        SAMEPERIODLASTYEAR('Date'[Date])
    )
RETURN
    CurrentSales - PreviousSales`,
          note: "Use variables for complex calculations",
        },
      ],
    },
    {
      title: "Visualization",
      items: [
        {
          title: "Basic Charts",
          content: "Create effective visualizations",
          code: `# KPI Cards
Metric: Total Sales
Target: Sales Goal
Status: Conditional formatting

# Charts
Line: Time series analysis
Bar: Category comparisons
Scatter: Correlation analysis
Map: Geographic data

# Tables & Matrix
Show/Hide totals
Conditional formatting
Drill-through enabled`,
          note: "Choose visuals based on data story",
        },
        {
          title: "Advanced Visuals",
          content: "Custom and complex visualizations",
          code: `# Custom Visuals
Import from marketplace:
- Sankey diagram
- Bullet chart
- Decomposition tree

# Visual Interactions
Format → Edit interactions
- Filter
- Highlight
- None

# Drill-through
Create drill-through page
Select fields to include
Add drill-through filters`,
          note: "Test custom visuals for performance",
        },
      ],
    },
  ],
};

export default powerBICheatSheet;
